import React, { useEffect, useState } from 'react'
import Icons from '../../../../Constants/Icons'
import { apiCall_getAdminEventTypes } from '../../../../Core/Apicall'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../../../Config/Actions/loadingActions'
import { useFormContext } from '../FormProvider'
import styles from '../../../Style'

function EventTypeModel () {
  const { formData, setFormData, errors } = useFormContext()

  const [isOpen, setIsOpen] = useState(false)
  const [items, setArtType] = useState([])
  useEffect(() => {
    onApiEventTypeList()
  }, [])

  const dispatch = useDispatch()
  const onApiEventTypeList = async selectedPage => {
    dispatch(setLoadingTrue())
    const param = {
      status: null,
      offset: selectedPage?.selected + 1 || 1,
      limit: 15
    }
    try {
      const response = await apiCall_getAdminEventTypes(param)
      setArtType(response.data || [])
      dispatch(setLoadingFalse())
    } catch (error) {
      console.error('Error fetching event types:', error)
      dispatch(setLoadingFalse())
    }
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleItemClick = item => {
    setIsOpen(false)
    setFormData(prevForm => ({
      ...prevForm,
      ArtRunner: item.eventTypeName,
      eventTypeId: item.eventTypeId
    }))
  }
  const handleMouseLeave = () => {
    setIsOpen(false)
  }

  return (
    <div
      className={`mb-4 Category_name Subcategory_drop ${
        errors.ArtRunner ? 'invalid' : 'valid'
      }`}
      style={styles.CustomDrop}
    >
      <div onMouseLeave={handleMouseLeave} className='custom-dropdown'>
        <div
          onClick={toggleDropdown}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 26
          }}
        >
          <div
            style={{
              fontWeight: '400',
              color: 'white',
              width: '100%'
            }}
            className='custom-dropdown2'
          >
            {formData.ArtRunner === null || formData.ArtRunner === '' ? (
              <div style={{ color: 'rgb(129, 129, 129)' }}>Event Type</div>
            ) : (
              formData.ArtRunner
            )}
          </div>
          <div style={{ display: 'flex' }}>
            <img className='downArrowIcon' alt='' src={Icons.ic_down} />
          </div>
        </div>
        {isOpen && (
          <div style={{ position: 'absolute', width: '100%', left: '0px' }}>
            <div style={{ height: 10 }}></div>
            <ul className='dropdown-menu'>
              {items.map((item, index) => (
                <li
                  key={index.toString()}
                  style={
                    item.eventTypeName === 'Personal'
                      ? { display: 'none' }
                      : { display: '' }
                  }
                  className={
                    item.eventTypeName === formData.ArtRunner ? 'active' : ''
                  }
                  onClick={event => handleItemClick(item, event)}
                >
                  {item.eventTypeName}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default EventTypeModel
